<template>
  <MarketCard>
    <ResizeListener :class="classes.resize" :onResize="onResize" />
    <CardHeader :eventId="eventId" />
    <div
      :class="[
        { [classes.useLeftContent]: !useInlineEventNames },
        classes.content
      ]"
    >
      <EventNameStacked
        v-if="!useInlineEventNames"
        :class="[classes.leftContent, 'event-name']"
        :marketId="marketId"
        :eventId="eventId"
      />
      <EventNameInline
        v-else
        :class="classes.inlineBanner"
        :marketId="marketId"
        :eventId="eventId"
        :useTeamNames="true"
      />
      <div :class="classes.rightContent">
        <PromoLogo
          :class="classes.promoLogo"
          :promoMarketName="market?.promoMarketName"
          :marketName="market?.marketName"
        />
        <div :class="[classes.promoWrapper]">
          <PromoFittedText
            :promoText="promoText"
            alignment="center"
            justifyContent="center"
          ></PromoFittedText>
        </div>
        <Button
          :class="[classes.oddsButton]"
          :marketId="marketId"
          :option="option"
        />
      </div>
    </div>
  </MarketCard>
</template>
<script lang="ts">
import { computed, defineComponent, ref } from "vue";
import MarketCard from "../../../styled/MarketCard.vue";
import CardHeader from "../../../CardHeader.vue";
import EventNameInline from "../../../EventNameBadges.vue";
import PromoLogo from "../Logo.vue";
import EventNameStacked from "../../../EventNamesBadgesStacked.vue";
import { createUseStyles } from "@fresh8/vue-jss/src";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { composeMarket } from "@fresh8/ad-data-composition/src/betData";
import PromoFittedText from "../../../PromoFittedText.vue";
import Button from "../Button.vue";
import ResizeListener from "../../../ResizeListener.vue";

import { injectPromoOption } from "../../../../hooks/usePromoOption";

const useStyles = createUseStyles({
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "100%"
  },
  useLeftContent: {
    flexDirection: "row"
  },
  inlineBanner: {
    "& .competitors .banner": {
      maxWidth: "unset",
      "&.right": {
        marginLeft: "15px",
        paddingRight: "10px"
      },
      "&.left": {
        marginRight: "15px",
        paddingLeft: "10px"
      }
    },
    marginTop: "12px !important",
    "& .banner": {
      height: "34px",

      "& .badge": {
        maxWidth: "60px",
        marginTop: "10px"
      },

      "& .jersey": {
        maxWidth: "60px",
        marginTop: "10px"
      },

      "& .vs": {
        height: "34px"
      },
      "& div": {
        fontSize: "14px"
      }
    }
  },
  leftContent: {
    width: "10%",
    flex: 1,
    maxWidth: "400px",

    "div&": {
      justifyContent: "space-around",
      margin: "14px 0"
    },

    "& .banner svg.badge": {
      maxWidth: "70px !important"
    },

    "& .banner .jersey": {
      maxWidth: "70px !important"
    }
  },
  rightContent: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: 2,
    padding: "10px 12px",
    borderLeft: props => `1px solid ${props.marketBorderColor || "#dcddf"}`
  },
  promoLogo: {
    boxSizing: "border-box",
    margin: "auto",
    height: "24px"
  },
  promoWrapper: {
    flex: "1 1 0px",
    display: "flex",
    width: "100%",
    padding: "3px 8px 3px",
    overflow: "hidden",
    boxSizing: "border-box",
    minHeight: "0px",
    flexDirection: "column"
  },
  oddsButton: {
    height: "35px",
    width: "100%",
    "& .odds-text": {
      fontSize: "14px"
    }
  },
  resize: {
    pointerEvents: "none",
    zIndex: -99
  }
});

export default defineComponent({
  components: {
    CardHeader,
    MarketCard,
    PromoLogo,
    EventNameInline,
    EventNameStacked,
    PromoFittedText,
    Button,
    ResizeListener
  },
  props: {
    eventId: {
      type: String,
      required: true
    },
    marketId: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const brandContext = injectBrand();
    const market = composeMarket(props.marketId);
    const option = injectPromoOption();

    const useInlineEventNames = ref(false);

    const onResize = size => {
      useInlineEventNames.value = size.width < 400;

      return size;
    };

    const reactiveStyles = computed(() => ({
      ...(brandContext?.adTemplateBranding.value || {})
    }));
    const classes = useStyles(reactiveStyles);

    return {
      useInlineEventNames,
      onResize,
      option,
      market,
      classes,
      promoText: computed(() => option.value?.promoText || "")
    };
  }
});
</script>
